module.exports = __webpack_public_path__ + "static/media/exercise-equipment-removal.ae934bc5.svg";